import { OffCanvasChildComponent } from 'src/app/model/off-canvas-child-component';
import { OffCanvasService } from 'src/app/services';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    templateUrl: './info-draw-list-info.component.html',
    styleUrls: ['./info-draw-list-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InfoDrawListInfoComponent extends OffCanvasChildComponent
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }
}
